export default __webpack_public_path__ + "static/media/illustration-bg.11f84c27.svg";